import React, {createContext, useCallback, useContext, useState} from 'react';
import {isEqual, isFunction} from "lodash";
import {initialFilter} from "./InvestigationsUIHelpers";

const InvestigationsUIContext = createContext();

export function useInvestigationsUIContext() {
    return useContext(InvestigationsUIContext);
}

export function InvestigationsUIProvider({investigationsUIEvents, children}) {

    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const [ids, setIds] = useState([]);
    const setQueryParams = useCallback(nextQueryParams => {
        setQueryParamsBase(prevQueryParams => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);


    const value = {
        queryParams,
        setQueryParamsBase,
        setQueryParams,
        ids, 
        setIds,
        newInvestigationButtonClick: investigationsUIEvents.newInvestigationButtonClick,
        viewInvestigationButtonClick: investigationsUIEvents.viewInvestigationButtonClick,
        deleteInvestigationButtonClick: investigationsUIEvents.deleteInvestigationButtonClick
    }

    return <InvestigationsUIContext.Provider value={value}>{children}</InvestigationsUIContext.Provider>

}